import ExportPage from "../pages/app/ExportPage";

export const exportRoute = (ssr = false) => [
  {
    path: "/:lang?/export/",
    tag: "export",
    type: "export",
    component: ssr ? ExportPage : () => import("../pages/app/ExportPage"),
    isSsr: ssr ?? false,
  },
];
